window.addEventListener('load', function() {
    const aboutPageContainer = document.querySelector('.about-page-container');
    const aboutPageTabs = document.querySelectorAll('.about-page__tabs__list__item');
    const aboutPageContent = document.querySelectorAll('.about-page__content__body');

    if(aboutPageTabs) aboutPageTabs.forEach(function(aboutPageTab, index) { 
        aboutPageTab.addEventListener('click', function(e) {
            e.preventDefault();
            const activeTab = document.querySelector('.about-page__tabs__list__item.v--active');
            const activeContent = document.querySelector('.about-page__content__body.v--active');
            aboutPageContainer.classList.remove('v--first-tab-active');
            activeTab.classList.remove('v--active');
            activeContent.classList.remove('v--active');
            if(aboutPageTab === aboutPageTab.parentNode.firstElementChild) aboutPageContainer.classList.add('v--first-tab-active');
            aboutPageTab.classList.add('v--active');
            aboutPageContent[index].classList.add('v--active');
        });
    });

    const toggleBioBtns = this.document.querySelectorAll('.team__list__item__toggle_bio');
    const bios = document.querySelectorAll('.team__list__item');

    if(toggleBioBtns) toggleBioBtns.forEach(function(toggleBioBtn, index) { 
        toggleBioBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const activeBio = document.querySelector('.team__list__item.v--active');
            const activeButton = document.querySelector('.team__list__item__toggle_bio.v--active');

            toggleBioBtn.classList.add('v--active');
            toggleBioBtn.innerHTML = '[ - ]';
            bios[index].classList.add('v--active');

            if(activeBio) {
                activeButton.classList.remove('v--active');
                activeBio.classList.remove('v--active');
                activeButton.innerHTML = '[ + ]';
            }


            // if(activeButton) {
                
            // } else {
            //     toggleBioBtn.classList.add('v--active');
            //     toggleBioBtn.innerHTML = '[ - ]';
            //     bios[index].classList.add('v--active');
            // }
        });
    });
});